<template>
  <div class="popup">
    <div class="popup_header mb_20">
      <div class="flex mb_20">
        <div class="flex w_220 mr_20">
          <el-input
            v-model="tableParams.source_name"
            class="mr_20"
            placeholder="请输入内容"
            @keyup.enter.native="getTableDataSearch()"
          ></el-input>
          <el-button
            @click="getTableDataSearch()"
            type="primary"
          >搜索</el-button>
        </div>
        <el-button
          @click="resetTableData"
          type="danger"
        >重置</el-button>
      </div>
    </div>
    <div class="popup_main">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="mb_20"
      >
        <el-table-column
          prop="source_name"
          label="境内货源地"
          width="180" align="center"
        ></el-table-column>
        <el-table-column
          prop="source_code"
          label="编码"
          width="180" align="center"
        ></el-table-column>
        <el-table-column
          prop="city_name"
          label="所在城市" align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="r">
            <el-button
              @click="sourceOfGoodsSelected(r.$index,r.row)"
              type="text"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex justify_end">
      <el-pagination
        @current-change="pageChange"
        background
        layout="prev, pager, next"
        :total="tableTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      tableData: [],
      tableTotal: 0,
      tableParams: {
        pageNum: 1,
        pageSize: 10,
        source_name: '',
      },
    };
  },
  created(){
    this.getTableData();
  },
  methods: {
    sourceOfGoodsSelected(i,r){
      // let obj = {
      //   i,
      //   r,
      // };
      // this.$emit('sourceOfGoodsSelected',obj);
      this.$emit('sourceOfGoodsSelected',r);
    },
    resetTableData(){
      this.goodsSourParams = {
        pageNum: 1,
        pageSize: 10,
        source_name: '',
      };
      this.getTableData();
    },
    pageChange(i){
      this.tableParams.pageNum = i;
      this.getTableData();
    },
    getTableDataSearch(){
      this.tableParams.pageNum = 1;
      this.getTableData();
    },
    getTableData(){
      this.$axios
        .get("/user/infoSourceareas/getPage",{
          params: this.tableParams,
        })
        .then(res => {
          if (res.status == 200) {
            this.tableData = res.data.page.list;
            this.tableTotal = res.data.page.total;
          }
        });
    },
  },
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/sourceOfGoods.vue